// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import './HotSelling.css';
// const HotSelling = () => {
//   const [images, setImages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const imageRefs = useRef([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchImages = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}HotSelling`);
//         if (!response.ok) {
//           throw new Error('Failed to fetch data');
//         }
//         const data = await response.json();
//         console.log("HotSelling Data - ", data.data);
//         setImages(data.data);
//       } catch (error) {
//         setError(error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchImages();
//   }, []);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add('active');
//           } else {
//             entry.target.classList.remove('active');
//           }
//         });
//       },
//       { threshold: 0.1 }
//     );

//     imageRefs.current.forEach((ref) => {
//       if (ref) {
//         observer.observe(ref);
//       }
//     });

//     return () => {
//       imageRefs.current.forEach((ref) => {
//         if (ref) {
//           observer.unobserve(ref);
//         }
//       });
//     };
//   }, [images]);

//   const handleImageClick = (id, name) => {
//     console.log("iiccdd",id);
//     sessionStorage.setItem('tripPackageId', id);
//     // const link = id === 1 ? '/Ladakh-Stay' : `/TripPackages/${name}`;
//     const link = id === 1 ? '/BikePackage' : `/carPackage`;
//     navigate(link);
//   };

//   if (loading) {
//     return <p>Loading...</p>;
//   }

//   if (error) {
//     return <p>Error: {error}</p>;
//   }

//   return (
// <section className="container-fluid pb-5">
//   <div className="row g-0">
//     {images.map((image, index) => {
//       const labels = ["Hotel", "Bike", "Car"];
//       return (
//         <div
//           key={image.Id}
//           className="col-md-4 image-item"
//           ref={(el) => (imageRefs.current[index] = el)}
//           onClick={() => handleImageClick(image.Id, image.Name)}
//         >
//           <div className="image-wrapper">
//             <img
//               src={image.Image}
//               alt={image.Name}
//               className="grid-image"
//             />
//             <div className="glass-overlay">
//               <span>{labels[index]}</span>
//             </div>
//           </div>
//         </div>
//       );
//     })}
//   </div>
// </section>
//   );
// };

// export default HotSelling;


import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './HotSelling.css';

const HotSelling = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const imageRefs = useRef([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}HotSelling`);
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const data = await response.json();
        console.log("HotSelling Data - ", data.data);
        setImages(data.data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          } else {
            entry.target.classList.remove('active');
          }
        });
      },
      { threshold: 0.1 }
    );

    imageRefs.current.forEach((ref) => {
      if (ref) {
        observer.observe(ref);
      }
    });

    return () => {
      imageRefs.current.forEach((ref) => {
        if (ref) {
          observer.unobserve(ref);
        }
      });
    };
  }, [images]);

  const handleImageClick = (id, name, label) => {
    console.log("Clicked ID:", id);
    sessionStorage.setItem('tripPackageId', id);

    let link = '/';
    switch (label.toLowerCase()) {
      case 'hotel':
        link = '/hotel-package';
        break;
      case 'bike':
        link = '/bike-package';
        break;
      case 'car':
        link = '/car-package';
        break;
      default:
        link = '/';
    }

    navigate(link);
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>Error: {error}</p>;
  }

  const labels = ["Hotel", "Bike", "Car"];

  return (
    <section className="container-fluid pb-5">
      <div className="row g-0">
        {images.map((image, index) => {
          const label = labels[index] || 'Explore';
          return (
            <div
              key={image.Id}
              className="col-md-4 image-item"
              ref={(el) => (imageRefs.current[index] = el)}
              onClick={() => handleImageClick(image.Id, image.Name, label)}
            >
              <div className="image-wrapper">
                <img
                  src={image.Image}
                  alt={image.Name}
                  className="grid-image"
                />
                
                <div className="credits">
                  <span>{label}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default HotSelling;
